import React, { Component } from 'react';
import {Button} from 'reactstrap';
import FormattedPrice from '../formatted-price/FormattedPrice';


class DeviceDetailsPrice extends Component {
    constructor(props) {
    super(props);
  }

  getPriceDescription(){
    for(let i=0; i<this.props.priceTypes.length;i++){
      if(this.props.mobileOrderType == this.props.priceTypes[i].name){
        return this.props.priceTypes[i].value;
      }
    }
  }

  getFormAttributes(){
    let formAttributes = [];

    for (let name in this.props){
        if(this.props.hasOwnProperty(name) && this.props[name] != null){
          formAttributes.push({name: name, value: this.props[name]});
        }
    }

    return formAttributes;
  }
  clearProspect(){
    console.log('Clear prospect>>>>');
    localStorage.removeItem('prospectUuid');
    localStorage.removeItem('offerId');
    localStorage.removeItem('plan-name');
    localStorage.removeItem('handset-name');
    localStorage.removeItem('prepayHandsetId');
    localStorage.removeItem('IONOrderReference');
    localStorage.removeItem('planToggle');
  }
  render() {
  
    return (        
      <form action={this.props.submitUrl} method="POST">
      
        {this.getFormAttributes().map((formAttribute, index) => {
            return (
              <input type="hidden" name={formAttribute.name} value={formAttribute.value} key={index} />
            );
        })}

        <Button className="mr-1 mt-1 mb-1" onClick={() => {this.clearProspect()}} type='submit'>
            <span className="device-price-description">{this.getPriceDescription()}</span>
            <span><FormattedPrice fromPrice={this.props.fromPrice} price={this.props.price} /></span>
        </Button>
      </form>
   );
  }
}

export default DeviceDetailsPrice;